export default {
  name: 'Johnny Testing Signup Form',
  title: {
    color: '#0e0e0e',
    text: 'GIVE ME ALL THE MONEY NOW!',
  },
  description: {
    color: '#0e0e0e',
    text: 'Give us your email if you want to live',
  },
  display_type: 'popover',
  contact_fields: [
    {
      field_name: 'email',
      required: true,
    },
    {
      field_name: 'last_name',
      required: true,
    },
    {
      field_name: 'first_name',
      required: true,
    },
    {
      field_name: 'phone',
      required: false,
    },
  ],
  contactgroup_ids: ['13'],
  button: {
    text: 'Give me money',
    text_color: '#0e0e0e',
    background_color: '#ffffff',
  },
  background_color: '#0e0e0e',
}
